(function () {
  'use strict';

  if (window.__secondaryMenuBound) return;
  window.__secondaryMenuBound = true;

  var ACCORDION_FALLBACK_MS = 550;
  var IMAGE_FADE_MS = 380;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prefersReducedMotion() {
    return reducedMotion.matches;
  }

  function clearDisclosureTimer(panel) {
    if (!panel) return;
    if (panel._disclosureTimer) {
      window.clearTimeout(panel._disclosureTimer);
      panel._disclosureTimer = null;
    }
    if (panel._disclosureHandler) {
      panel.removeEventListener('transitionend', panel._disclosureHandler);
      panel._disclosureHandler = null;
    }
  }

  function setDisclosure(panel, open, instant) {
    if (!panel) return;
    clearDisclosureTimer(panel);
    instant = instant || prefersReducedMotion();

    if (open) {
      panel.hidden = false;
      if (instant) {
        panel.classList.add('is-open');
        return;
      }
      panel.classList.remove('is-open');
      void panel.offsetHeight;
      window.requestAnimationFrame(function () {
        panel.classList.add('is-open');
      });
      return;
    }

    panel.classList.remove('is-open');
    if (instant || panel.hidden) {
      panel.hidden = true;
      return;
    }

    function finish(event) {
      if (event && event.target !== panel) return;
      if (event && event.propertyName && event.propertyName !== 'grid-template-rows') {
        return;
      }
      clearDisclosureTimer(panel);
      panel.hidden = true;
    }

    panel._disclosureHandler = finish;
    panel.addEventListener('transitionend', finish);
    panel._disclosureTimer = window.setTimeout(finish, ACCORDION_FALLBACK_MS);
  }

  function setToggleLabel(toggle, open) {
    if (!toggle) return;
    var label = toggle.querySelector('.visually-hidden');
    if (!label) return;
    var expand = toggle.getAttribute('data-label-expand');
    var collapse = toggle.getAttribute('data-label-collapse');
    if (open && collapse) {
      label.textContent = collapse;
    } else if (!open && expand) {
      label.textContent = expand;
    }
  }

  function closeScope(scope, instant) {
    if (!scope) return;
    var toggles = scope.querySelectorAll('[data-accordion-toggle]');
    var panels = scope.querySelectorAll('[data-accordion-panel]');
    toggles.forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.classList.remove('is-open');
      setToggleLabel(toggle, false);
    });
    panels.forEach(function (panel) {
      setDisclosure(panel, false, instant);
    });
  }

  function openToggle(scope, toggle, instant) {
    if (!scope || !toggle) return;
    var panelId = toggle.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    closeScope(scope, instant);
    toggle.setAttribute('aria-expanded', 'true');
    toggle.classList.add('is-open');
    setToggleLabel(toggle, true);
    setDisclosure(panel, true, instant);
  }

  function swapImage(media, nextSrc, nextAlt) {
    if (!media || !nextSrc || media.getAttribute('src') === nextSrc) return;

    var reduced = prefersReducedMotion();

    function applyImage() {
      media.setAttribute('src', nextSrc);
      media.removeAttribute('srcset');
      if (nextAlt != null) media.alt = nextAlt;
    }

    function clearFade() {
      if (media._fadeTimer) {
        window.clearTimeout(media._fadeTimer);
        media._fadeTimer = null;
      }
      if (media._fadeHandler) {
        media.removeEventListener('transitionend', media._fadeHandler);
        media._fadeHandler = null;
      }
    }

    if (reduced) {
      clearFade();
      applyImage();
      media.classList.remove('is-fading');
      return;
    }

    clearFade();
    media.classList.remove('is-fading');
    void media.offsetWidth;
    media.classList.add('is-fading');

    function onFadedOut(event) {
      if (event && event.propertyName && event.propertyName !== 'opacity') return;
      clearFade();
      applyImage();
      window.requestAnimationFrame(function () {
        media.classList.remove('is-fading');
      });
    }

    media._fadeHandler = onFadedOut;
    media.addEventListener('transitionend', onFadedOut);
    media._fadeTimer = window.setTimeout(onFadedOut, IMAGE_FADE_MS);
  }

  function bindPanelHover(panel) {
    if (!panel || panel.dataset.hoverBound === 'true') return;
    panel.dataset.hoverBound = 'true';

    var media = panel.querySelector('[data-secondary-menu-media]');
    var list = panel.querySelector('.secondary-menu__panel-list');
    var links = panel.querySelectorAll('.secondary-menu__panel-link');
    if (!list) return;

    function activate(link) {
      if (panel._activeLink === link) return;
      links.forEach(function (el) {
        el.classList.remove('is-active');
      });
      link.classList.add('is-active');
      panel._activeLink = link;
      var src = link.getAttribute('data-secondary-menu-image');
      if (media && src) {
        var label = link.querySelector('.secondary-menu__panel-label');
        swapImage(media, src, label ? label.textContent.trim() : '');
      }
    }

    links.forEach(function (link) {
      link.addEventListener('pointerenter', function () {
        activate(link);
      });
      link.addEventListener('focusin', function () {
        activate(link);
      });
    });
  }

  function bindRoot(root) {
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';
    root.querySelectorAll('[data-accordion-panel]').forEach(bindPanelHover);
  }

  document.querySelectorAll('[data-secondary-menu][data-layout="dropdown"]').forEach(bindRoot);

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-secondary-menu] [data-accordion-toggle]');
    if (!toggle) return;

    var scope = toggle.closest('[data-secondary-menu-scope]');
    var root = toggle.closest('[data-secondary-menu]');
    var panelId = toggle.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : null;
    if (!scope || !root || !panel) return;

    var willOpen = toggle.getAttribute('aria-expanded') !== 'true';
    closeScope(scope, false);

    if (willOpen) {
      toggle.setAttribute('aria-expanded', 'true');
      toggle.classList.add('is-open');
      setToggleLabel(toggle, true);
      setDisclosure(panel, true, false);
    }
  });

  function panelIdFromTab(tab) {
    return tab && tab.getAttribute ? (tab.getAttribute('data-secondary-menu-panel') || '').trim() : '';
  }

  function setActiveTabs(root, panel) {
    if (!root || !panel) return;
    root.querySelectorAll('[data-secondary-menu-panel]').forEach(function (tab) {
      var on = panelIdFromTab(tab) === panel;
      tab.classList.toggle('is-current', on);
      if (on) {
        tab.setAttribute('aria-current', 'true');
      } else {
        tab.removeAttribute('aria-current');
      }
    });
    var currentTab = root.querySelector('[data-secondary-menu-panel="' + panel + '"]');
    var label = currentTab ? (currentTab.textContent || '').trim() : '';
    if (label) {
      var mobileLabel = root.querySelector('.secondary-menu__accordion-label');
      if (mobileLabel) mobileLabel.textContent = label;
    }
    var mobileScope = root.querySelector('[data-secondary-menu-scope="mobile"]');
    if (mobileScope) closeScope(mobileScope, false);
  }

  function showTabPanel(panel, root) {
    if (!panel) return;
    document.querySelectorAll('[data-tab-panel]').forEach(function (el) {
      var wrap = el.closest('.shopify-section') || el;
      wrap.hidden = el.getAttribute('data-tab-panel') !== panel;
    });
    if (root) setActiveTabs(root, panel);
    if (history.replaceState) {
      var url = window.location.pathname + window.location.search + '#' + panel;
      history.replaceState(null, '', url);
    }
  }

  function defaultPanel(root) {
    if (!root) return '';
    var hash = (window.location.hash || '').replace('#', '');
    if (hash && root.querySelector('[data-secondary-menu-panel="' + hash + '"]')) {
      return hash;
    }
    var current = root.querySelector('[data-secondary-menu-panel].is-current');
    if (current) return panelIdFromTab(current);
    var first = root.querySelector('[data-secondary-menu-panel]');
    return first ? panelIdFromTab(first) : '';
  }

  function bindTabRoot(root) {
    if (!root || root.dataset.tabsBound === 'true') return;
    if (!root.querySelector('[data-secondary-menu-panel]')) return;
    root.dataset.tabsBound = 'true';
    var panel = defaultPanel(root);
    if (panel) showTabPanel(panel, root);
  }

  document.querySelectorAll('[data-secondary-menu]').forEach(bindTabRoot);

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-secondary-menu-panel]');
    if (!tab) return;
    var root = tab.closest('[data-secondary-menu]');
    var panel = panelIdFromTab(tab);
    if (!root || !panel) return;
    event.preventDefault();
    showTabPanel(panel, root);
  });

  window.addEventListener('hashchange', function () {
    document.querySelectorAll('[data-secondary-menu]').forEach(function (root) {
      if (!root.querySelector('[data-secondary-menu-panel]')) return;
      var panel = defaultPanel(root);
      if (panel) showTabPanel(panel, root);
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('[data-secondary-menu][data-layout="dropdown"]').forEach(bindRoot);
    event.target.querySelectorAll('[data-secondary-menu]').forEach(bindTabRoot);
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (!event.target || !event.target.querySelector) return;
    var stack = event.target.querySelector('[data-tab-panel]');
    if (!stack) return;
    var panel = (stack.getAttribute('data-tab-panel') || '').trim();
    var root = document.querySelector('[data-secondary-menu]');
    if (panel && root) showTabPanel(panel, root);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var tab = event.target && event.target.closest ? event.target.closest('[data-secondary-menu-panel]') : null;
    if (tab) {
      var tabRoot = tab.closest('[data-secondary-menu]');
      var tabPanel = panelIdFromTab(tab);
      if (tabRoot && tabPanel) showTabPanel(tabPanel, tabRoot);
      return;
    }

    var item = event.target && event.target.closest ? event.target.closest('.secondary-menu__panel-link') : null;
    var groupBtn = event.target && event.target.closest ? event.target.closest('[data-secondary-menu-group]') : null;
    var root = event.target && event.target.closest ? event.target.closest('[data-secondary-menu]') : null;
    if (!root) return;

    var desktop = root.querySelector('[data-secondary-menu-scope="desktop"]');
    var toggle = groupBtn;
    if (!toggle && item) {
      var panel = item.closest('[data-accordion-panel]');
      if (panel && panel.id && desktop) {
        toggle = desktop.querySelector('[aria-controls="' + panel.id + '"]');
      }
    }
    if (desktop && toggle) openToggle(desktop, toggle, true);
  });
})();
